import React from 'react';
import styles from './Content.module.scss';

const NamingConvention: React.FC = () => {
    return(
        <div className={styles.namingConvention}>
            <h1>LSB Naming Convention</h1>
            <ol>
            <li>Please enter the name of the location and the specific site or asset type. e.g. 'Cheltenham Spa St Peters Relay Room.'</li>
            <li>Hyphens may only be used with a preceding and succeeding space, e.g. “– “, unless it is part of the accepted place name, e.g. “Henley-in-Arden”.</li>
            <li>Ampersand may only be used if it is part of an accepted place name, e.g. “Cobham & Stoke D'Abernon Stn”</li>
            <li>The following acronyms and abbreviations are acceptable:</li>
            </ol>
            <table>
                <tr>
                    <td>Accommodation</td>
                    <td>Accom</td>
                </tr>
                <tr>
                    <td>Gate Box</td>
                    <td>GB</td>
                </tr>
                <tr>
                    <td>Handsignalman(‘s)</td>
                    <td>HSM</td>
                </tr>
                <tr>
                    <td>Junction</td>
                    <td>Jct</td>
                </tr>
                <tr>
                    <td>Level Crossing</td>
                    <td>LC</td>
                </tr>
                <tr>
                    <td>Light Maintenance Depot</td>
                    <td>LMD</td>
                </tr>
                <tr>
                    <td>Line Side Building</td>
                    <td>LSB</td>
                </tr>
                <tr>
                    <td>Maintenance Delivery Unit</td>
                    <td>MDU</td>
                </tr>
                <tr>
                    <td>Permanent Way</td>
                    <td>P.Way</td>
                </tr>
                <tr>
                    <td>Power Signal Box/Panel Signal Box</td>
                    <td>PSB</td>
                </tr>
                <tr>
                    <td>Relocatable Equipment Building</td>
                    <td>REB</td>
                </tr>
                <tr>
                    <td>Saint</td>
                    <td>St</td>
                </tr>
                <tr>
                    <td>Signal Box</td>
                    <td>SB</td>
                </tr>
                <tr>
                    <td>Station</td>
                    <td>Stn</td>
                </tr>
                <tr>
                    <td>Track Paralleling Hut</td>
                    <td>TP Hut</td>
                </tr>
                <tr>
                    <td>Track Section Cabin</td>
                    <td>TSC</td>
                </tr>                
            </table>
        </div>
    )
}

export default NamingConvention;